// about section images import
import img01 from '../images/about/01.png';
import img02 from '../images/about/02.png';
import img03 from '../images/about/03.png';
import img04 from '../images/about/04.png';
// work section images import
import workImg01 from "../images/work/01.png";
import workImg02 from "../images/work/02.png";
import workImg03 from "../images/work/03.png";
import workImg04 from "../images/work/03.png";
// about section cards content
export  const aboutContentList = [
    {
        imgUrl: img01,
        imgAlt: 'two-rings',
        countNumber: 5677,
        countTitle: "عدد حالات الزواج",
    },
    {
        imgUrl: img02,
        imgAlt: 'relation',
        countNumber: 29000,
        countTitle: " عدد الأعضاء الإجمالي",
    },
    {
        imgUrl: img03,
        imgAlt: 'man-charecter',
        countNumber: 14000,
        countTitle: "عدد الأعضاء الرجال",
    },
    {
        imgUrl: img04,
        imgAlt: 'woman-charecter',
        countNumber: '15000',
        countTitle: "عدد الأعضاء النساء",
    },
]
// work section card contents
export  const stepsData = [
    {
      id: "01",
      image: workImg01,
      title: "انشئ حساب لك",
      description: "قم بانشاء حساب لك بخطوات بسيطة",
    },
    {
      id: "02",
      image: workImg02,
      title: "ابحث عن شريكك",
      description: "قم بالبحث عن شريك حياتك بافضل الادوات",
    },
    {
      id: "03",
      image: workImg03,
      title: "قم بمراسلة شريكك",
      description: "يمكنك التطبيق من مراسلة شريكك برقابة",
    },
    {
      id: "04",
      image: workImg04,
      title: "قدم طلب الزواج",
      description: "يمكنك تقديم طلب الزواج في حال الاتفاق",
    },
  ];
